import { sample } from 'lodash';
import React, { Component } from 'react';
import * as emojis from './icons/CallResultPopupEmojiIcons';

type EmojiGroup = typeof emojis.normal | typeof emojis.perfect;

const getEmojiGroup = (spottedPhrases: number, totalPhrases: number) => {
    const percentage = (spottedPhrases / totalPhrases) * 100;

    if (percentage < 20) return null; // emojis.disaster;
    if (percentage < 40) return null; // emojis.bad;
    if (percentage < 80) return emojis.normal;
    return emojis.perfect;
};

class Emoji extends Component<{ spottedPhrasesScore?: number; totalPhrasesScore?: number; visible: boolean }> {
    state: { emojiName: string | null; group: EmojiGroup | null } = {
        emojiName: null,
        group: null
    };

    static defaultProps = {
        spottedPhrasesScore: 0,
        totalPhrasesScore: 0
    };

    componentDidMount() {
        this.syncSelectedEmoji();
    }

    componentDidUpdate(prevProps: Readonly<{ spottedPhrasesScore?: number; totalPhrasesScore?: number; visible: boolean }>) {
        const visibilityChanged = prevProps.visible !== this.props.visible;
        const scoreChanged =
            prevProps.spottedPhrasesScore !== this.props.spottedPhrasesScore ||
            prevProps.totalPhrasesScore !== this.props.totalPhrasesScore;

        if (visibilityChanged || scoreChanged) {
            this.syncSelectedEmoji();
        }
    }

    shouldComponentUpdate(
        nextProps: Readonly<{ spottedPhrasesScore?: number; totalPhrasesScore?: number; visible: boolean }>,
        nextState: Readonly<{ emojiName: string | null; group: EmojiGroup | null }>
    ) {
        return (
            nextProps.visible !== this.props.visible ||
            nextProps.spottedPhrasesScore !== this.props.spottedPhrasesScore ||
            nextProps.totalPhrasesScore !== this.props.totalPhrasesScore ||
            nextState.emojiName !== this.state.emojiName ||
            nextState.group !== this.state.group
        );
    }

    syncSelectedEmoji() {
        const { spottedPhrasesScore, totalPhrasesScore, visible } = this.props;
        const safeSpottedPhrasesScore = spottedPhrasesScore ?? 0;
        const safeTotalPhrasesScore = totalPhrasesScore ?? 0;
        const group = safeTotalPhrasesScore ? getEmojiGroup(safeSpottedPhrasesScore, safeTotalPhrasesScore) : null;

        if (!visible || group === null) {
            if (this.state.emojiName !== null || this.state.group !== null) {
                this.setState({ emojiName: null, group: null });
            }
            return;
        }

        const groupChanged = group !== this.state.group;
        const needsInitialSelection = this.state.emojiName === null;

        if (groupChanged || needsInitialSelection) {
            this.setState({
                group,
                emojiName: (sample(Object.keys(group)) as keyof EmojiGroup | undefined) || null
            });
        }
    }

    render() {
        const { spottedPhrasesScore, totalPhrasesScore } = this.props;
        const safeSpottedPhrasesScore = spottedPhrasesScore ?? 0;
        const safeTotalPhrasesScore = totalPhrasesScore ?? 0;
        if (!safeTotalPhrasesScore) return null;

        const group = this.state.group ?? getEmojiGroup(safeSpottedPhrasesScore, safeTotalPhrasesScore);
        const randomEmojiName = this.state.emojiName;

        if (group === null || !randomEmojiName) {
            return <div />;
        }

        const RandomEmoji = group[randomEmojiName as keyof EmojiGroup] as React.ComponentType;

        return (
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    transform: 'scale(0.75)',
                    transformOrigin: 'center center'
                }}>
                <RandomEmoji />
            </div>
        );
    }
}

export default Emoji;
